import axios from 'axios';

export default {
    fetchMetaData() {
        return axios.get('/layout/fetchMetaData');
    },
};
